import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SignatureService {
    opened: boolean = false;
    private savedDataSubject = new BehaviorSubject<string | null>(null); // Per condividere i dati
    savedData$ = this.savedDataSubject.asObservable(); // Observable per sottoscriversi ai dati

    constructor() {
    }

    open() {
        this.opened = true;
    }

    close() {
        this.opened = false;
    }

    saveData(data: string) {
        this.savedDataSubject.next(data); // Aggiorna i dati salvati
        this.close(); // Chiude la modale
    }

    resetData() {
        this.savedDataSubject.next(null); // Reset
    }


}
